import healthy from "../assets/images/yoga.png";
import food from "../assets/images/sustainable_food_system.png";
import ewaste from "../assets/images/renewable.png";
import waste from "../assets/images/reduce_waste.png";
import energy from "../assets/images/energy-saving.png";
import water from "../assets/images/save-water.png";
import plastic from "../assets/images/no-plastic.png";

const ThemeBaseRouting = [
    { lable: "Adopt Healthy Lifestyles", url: "/addopthealthylife", value: "Adopt Healthy Lifestyles" , icon: healthy, bgcolor: '#c7caff', key: 'lifestylesAdoptedCount'},
    { lable: "Adopt Sustainable Food Systems", url: "/addoptfood", value: "Adopt sustainable food systems" , icon: food, bgcolor: '#f6c2f3', key: 'foodSystemsCount'},
    { lable: "Reduce E-Waste", url: "/reduceewaste", value: "Reduce E-Waste" , icon: ewaste, bgcolor: '#dcf48c', key: 'eWasteReducedCount'},
    { lable: "Reduce Waste", url: "/reduce-waste", value: "Reduce Waste" , icon: waste, bgcolor: '#ffa6b0', key: 'wasteReducedCount'},
    { lable: "Save Energy", url: "/save-energy", value: "Save Energy" , icon: energy, bgcolor: '#fafabe', key: 'energySavedCount'},
    { lable: "Save Water", url: "/savewater", value: "Save Water" , icon: water, bgcolor: '#f6ca94', key: 'waterSavedCount'},
    { lable: "Say No to Single Use Plastic", url: "/saynoplastic", value: "Say No to Single Use Plastic" , icon: plastic, bgcolor: '#cdabeb', key: 'plasticReducedCount'},
]

export default ThemeBaseRouting;
